<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
  <div class="no-field-space">
    <form [formGroup]="form">
      <sc-flex>

        <sc-date-field formControlName="dateFrom" [label]="'from'| translate:['tmc-visit.reporting.visitor-export.filter.from',
              translationService.language]" [required]="true">
        </sc-date-field>

        <sc-content-spacer></sc-content-spacer>

        <sc-date-field formControlName="dateUntil" [label]="'to'| translate:['tmc-visit.reporting.visitor-export.filter.to',
              translationService.language]" [required]="true">
        </sc-date-field>

        <sc-content-spacer></sc-content-spacer>

        <button (click)="createExcel()" [disabled]="isCreateDisabled()" mat-flat-button>
          {{'export'| translate:['tmc-visit.reporting.visitor-export.action.export',
          translationService.language]}}</button>

      </sc-flex>
    </form>
  </div>

  <sc-content-spacer [vertical]="true"></sc-content-spacer>

  <sc-flex-fitting-content [vertical]="true">
    <sc-content-area [fitHeight]="true">
    </sc-content-area>

  </sc-flex-fitting-content>

</sc-flex>